import { Policy } from '@core/api';

export const isActiveInsurance = (policy: Policy): boolean =>
  policy.status === 'Effective' || policy.status === 'Valid';

export const hasExistingActiveInsurance = (policies: Policy[]): boolean =>
  policies.some(isActiveInsurance);

export const shouldShowExistingInsuranceModal = (
  policies: Policy[],
  hasShown: boolean
): boolean => {
  return !hasShown && hasExistingActiveInsurance(policies);
};
